//Import required modules
import React from "react";

//Import Styles
import "./Navigation.scss";

//Import Data
import picturesCategories from "../../../assets/data/pictureCategories.json";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faStar,
  faGlobe,
  faFeatherAlt,
  faMountain,
  faStreetView,
  faRing,
  faPaw,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Add required icons so that they can be referenced as strings in the app
library.add(
  fab,
  faStar,
  faGlobe,
  faFeatherAlt,
  faMountain,
  faStreetView,
  faRing,
  faPaw
);

//Navbar Component
const Navigation = (props, { store }) => {
  let { catSelected, setCatSelected, navSticky, showNav, setShowNav } = props;
  let picturesCategoriesFinal = picturesCategories.filter((obj) => obj.display);

  const handleToggle = () => {
    setShowNav(!showNav);
  };

  return (
    <div className={`navbar ${navSticky ? "stuck" : ""}`}>
      <div className={`navbar-large ${navSticky ? "sticky" : ""}`}>
        {picturesCategoriesFinal.map((obj, index) => {
          return (
            <div
              key={index}
              className={`navbar-large-item ${
                catSelected === obj.tabName ? "selected" : ""
              } ${obj.className === "star" ? "star" : ""}`}
              onClick={() => setCatSelected(obj.tabName)}
              title={obj.tabName}
            >
              <>
                <span
                  className={`category-icon ${
                    obj.tabName !== "Home" ? "hide" : ""
                  }`}
                >
                  <FontAwesomeIcon icon={obj.className} />
                </span>
                {obj.tabName !== "Home" ? (
                  <span className="category-title">{obj.tabName}</span>
                ) : null}
              </>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation;
